/**
 * Remove only inline white backgrounds pasted into Shopify policy content.
 *
 * CSS cannot safely match every serialized white value without embedding raw
 * color literals, so a detached probe lets the browser normalize the Admin
 * value before we replace it. Other inline highlight colors remain untouched.
 */
const legalBodies = document.querySelectorAll(
  ".shopify-policy__body, #MainContent[data-template^='page'] .page-content",
);

if (legalBodies.length > 0) {
  const probe = document.createElement('span');
  probe.hidden = true;
  document.documentElement.append(probe);

  probe.style.backgroundColor = 'white';
  const white = getComputedStyle(probe).backgroundColor;

  legalBodies.forEach((legalBody) => {
    legalBody.querySelectorAll('[style]').forEach((element) => {
      const inlineBackground = element.style.backgroundColor;

      if (!inlineBackground) return;

      probe.style.backgroundColor = inlineBackground;

      if (getComputedStyle(probe).backgroundColor === white) {
        element.style.backgroundColor = 'transparent';
      }
    });
  });

  probe.remove();
}
